// extracted by mini-css-extract-plugin
export default {"link":"DownloadLink_link__WSdaS","error":"DownloadLink_error__turrF","spinner":"DownloadLink_spinner__Kciec"};